import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Carousel from './Carousel';
import Footnote from './Footnote';
import Heading from '../../Heading';
import Images from './Images';
import MobileSelect from '../../../global/MobileSelect';
import Table from './Table';
import Wrapper from '../../../global/InnerWrapper';

import { filterTable, getModels } from './utils';

const Desktop = styled.div`
  @media ${p => p.theme.media.largePhone} {
    display: none;
  }
`;

const Mobile = styled.div`
  display: none;
  @media ${p => p.theme.media.largePhone} {
    display: block;
  }
`;

function SpecsSection({ specs }) {
  const [activeModels, setActiveModel] = useState(
    specs
      .map(spec => getModels(spec.table))
      .map(models => (models.length > 0 ? models[0] : null))
  );

  const handleModelChange = i => active => {
    setActiveModel(previousActiveModel => {
      const nextActiveModel = { ...previousActiveModel };
      nextActiveModel[i] = active;
      return nextActiveModel;
    });
  };

  const [modelChangeHandlers] = useState(
    specs.map((_, i) => handleModelChange(i))
  );

  return (
    <Wrapper as="section">
      <Heading hideOnMobile>Specifications & Dimensions</Heading>
      <Desktop>
        {specs.map((spec, i) => {
          const showFootnote = Boolean(spec.tableFootNote);
          return (
            <React.Fragment key={i}>
              <Carousel specs={[spec]} />
              {/* wrap spec in array to make it iterable for the carousel */}
              <Table table={spec.table} footNote={showFootnote} />
              {showFootnote ? (
                <Footnote footnotes={spec.tableFootNote} />
              ) : null}
            </React.Fragment>
          );
        })}
      </Desktop>
      <Mobile>
        {specs.map((spec, i) => {
          const showFootnote = Boolean(spec.tableFootNote);
          return (
            <React.Fragment key={i}>
              <MobileSelect
                onChange={modelChangeHandlers[i]}
                options={getModels(spec.table)}
              />
              <Images images={spec.images} />
              <Table
                table={filterTable(spec.table, activeModels[i])}
                footNote={showFootnote}
              />
              {showFootnote ? (
                <Footnote footnotes={spec.tableFootNote} />
              ) : null}
            </React.Fragment>
          );
        })}
      </Mobile>
    </Wrapper>
  );
}

SpecsSection.propTypes = {
  specs: PropTypes.arrayOf(
    PropTypes.shape({
      images: PropTypes.arrayOf(PropTypes.string).isRequired,
      table: PropTypes.string.isRequired
    })
  ).isRequired
};

export default SpecsSection;
